<template>
    <i :class="['far', 'fa-lg', value ? 'fa-check-square' : 'fa-square']" @click="$emit('click', $event.target)"
       v-bind="$attrs"></i>
</template>

<script>
    export default {
        props: {
            value: {
                required: true,
                type: Boolean
            }
        }
    }
</script>
